import { CHART_SMALL_FONT_WEIGHT } from './base-chart.constants';
import { ColorProvider } from './chart-color-provider';

export const COMMON_AXES_OPTIONS = {
    grid: {
        show: false,
        containLabel: true,
        left: 40,
        right: 20,
        top: 30,
        bottom: 40,
    },
    xAxis: {
        splitLine: {
            show: true,
        },
        axisLabel: {
            rotate: 0,
            padding: [5, 5, 5, 5], // Chart isn't rendered if the padding is a number.
            fontWeight: CHART_SMALL_FONT_WEIGHT,
        },
        axisLine: {
            show: true,
        },
        axisTick: {
            show: true,
        },
        data: ([] as any[]),
    },
    yAxis: {
        splitLine: {
            show: true,
        },
        axisLabel: {
            fontWeight: CHART_SMALL_FONT_WEIGHT,
            margin: 12,
        },
        axisLine: {
            show: true,
        },
        axisTick: {
            show: true,
        },
    },
};

export const AXES_CHART_OPTIONS_MAPPER = {
    grid: {
        show: 'showGridBorder',
    },
    xAxis: {
        axisLabel: {
            rotate: 'xAxisLabelsRotation',
        },
        axisLine: {
            show: 'showAxes',
        },
        axisTick: {
            show: 'showAxes',
        },
        splitLine: {
            show: 'showXAxisTickLines',
        },
    },
    yAxis: {
        axisLine: {
            show: 'showAxes',
        },
        axisTick: {
            show: 'showAxes',
        },
        splitLine: {
            lineStyle: {
                type: 'yAxisTickLineStyle',
            },
        },
    },
    legend: {
        show: 'showLegend',
    },
};

export const mapBaseAxesColorOptions = (colorProvider: ColorProvider) => ({
    xAxis: {
        splitLine: {
            lineStyle: {
                color: colorProvider.gridLineColor,
            },
        },
        axisLabel: {
            color: colorProvider.axisTextColor,
        },
        axisLine: {
            lineStyle: {
                color: colorProvider.axisLineColor,
            },
        },
        axisTick: {
            lineStyle: {
                color: colorProvider.axisLineColor,
            },
        },
    },
    yAxis: {
        splitLine: {
            lineStyle: {
                color: colorProvider.gridLineColor,
            },
        },
        axisLabel: {
            color: colorProvider.axisTextColor,
        },
        axisLine: {
            lineStyle: {
                color: colorProvider.axisLineColor,
            },
        },
        axisTick: {
            lineStyle: {
                color: colorProvider.axisLineColor,
            },
        },
    },
});
